<template>
  <alzata-dialog
    ref="modal"
    :title="taskItem?.id ? 'Edit Task Item' : 'Create Task Item'"
  >
    <div class="row g-2">
      <div class="col-12">
        <label for="title" class="small">Title</label>
        <input
          id="title"
          type="text"
          class="form-control"
          placeholder="Title"
          v-model="title"
        />

        <label for="description" class="small">Description</label>
        <textarea
          rows="5"
          id="description"
          type="text"
          class="form-control"
          placeholder="Description"
          v-model="description"
        ></textarea>

        <label for="category" class="small">Category</label>
        <input
          id="category"
          type="text"
          class="form-control"
          placeholder="Category"
          v-model="category"
        />

        <label for="linkUrl" class="small">Link URL</label>
        <input
          id="linkUrl"
          type="hyperlink"
          class="form-control"
          placeholder="Link URL"
          v-model="linkUrl"
        />

        <label for="dueDate" class="small">Due Date</label>
        <input class="form-control" v-model="dueDate" />

        <div v-if="taskItem?.id">
          <label for="assignedToUserId" class="small">Assigned To</label><br />
          <span
            >{{ assignedToVeteran?.lastName }},
            {{ assignedToVeteran?.firstName }}</span
          >
        </div>
        <div v-else>
          <label for="assignedToUserId" class="small">Assigned To</label>
          <br />
          <span v-for="veteran in veterans">
            <input
              type="checkbox"
              :value="veteran.id"
              v-model="selectedVeterans"
            />
            <span class="checkbox-label" style="margin-left: 8px">
              {{ veteran?.lastName }}, {{ veteran?.firstName }}
            </span>
            <br />
          </span>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="this.hide">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="save">Save</button>
    </template>
  </alzata-dialog>
</template>

<script>
import { getJson, postJson } from "../apis/baseApiClient";
import { DateTime } from "luxon";

export default {
  name: "EditTaskItemDialog",
  emits: ["save", "update"],
  data() {
    return {
      taskItem: null,
      title: null,
      description: null,
      linkUrl: null,
      category: null,
      dueDate: null,
      veterans: [],
      assignedToVeteran: null,
      selectedVeterans: [],
      errors: {
        assignedVets: false
      }
    };
  },
  methods: {
    async show(taskItem) {
      this.clear();
      this.selectedVeterans = [];
      this.assignedToVeteran = null;
      this.veterans = await getJson(
        "/api/v1/profiles?$filter=IsVeteran%20eq%20true&$orderby=LastName%20asc"
      );
      var assignedToVeteran = this.veterans.find(
        (v) => v.id == taskItem.assignedToUserId
      );

      this.taskItem = taskItem;
      this.title = taskItem.title;
      this.description = taskItem.description;
      this.linkUrl = taskItem.linkUrl;
      this.category = taskItem.category;
      this.dueDate = this.formatDate(taskItem.dueDate);
      this.assignedToVeteran = assignedToVeteran;

      this.$refs.modal.show();
    },
    clear() {
      this.selectedVeterans = null;
      this.assignedToVeteran = null;
      this.veterans = null;

      this.taskItem = null;
      this.title = null;
      this.description = null;
      this.linkUrl = null;
      this.category = null;
      this.dueDate = null;
    },
    hide() {
      this.$refs.modal.hide();
    },
    save() {
      if (this.taskItem?.id) {
        this.$emit("update", {
          id: this.taskItem.id,
          title: this.title,
          description: this.description,
          linkUrl: this.linkUrl,
          category: this.category,
          dueDate: this.dueDate,
          assignedToUserId: this.assignedToVeteran,
        });
      } else {
        this.$emit("save", {
          id: this.taskItem.id,
          title: this.title,
          description: this.description,
          linkUrl: this.linkUrl,
          category: this.category,
          dueDate: this.dueDate,
          assignedToUserIds: this.selectedVeterans,
        });
      }
    },
    formatDate(dateString) {
      if (!dateString) return null;

      const date = DateTime.fromISO(dateString);
      const formatted = date.toLocaleString(DateTime.DATE_SHORT);
      return formatted;
    },
  },
};
</script>
